import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  public refreshSubject = new Subject<string>();
  constructor(private utilsService: UtilsService) {}

  fnRefreshTable(url: string) {
    this.refreshSubject.next(url);
  }

  fnIconRotate() {
    this.utilsService.rotateIcon = true;
  }

  fnIconStop() {
    this.utilsService.rotateIcon = false;
  }
}
